<template>
  <el-container>
    <el-main class="CalendarLayout" style="background-color: #fff;">
      <el-table :data="myInterview" style="width: 100%; margin-top: 10px;">
        <el-table-column label="咨询日期" align="left" width="120px">
          <template slot-scope="scope" center>
            {{ scope.row.SchedulDate }}
          </template>
        </el-table-column>
        <el-table-column label="咨询时间" min-width="11%">
          <template slot-scope="scope">
            <span style="margin-left: 10px;"><b>{{scope.row.StartTime.substring(0,5)}}</b><span>--</span><b>{{scope.row.FinishTime.substring(0,5)}}</b></span>
          </template>
        </el-table-column>
        <el-table-column label="咨询状态" min-width="7%">
          <template slot-scope="scope">
        <span style="">
          {{ scope.row.Status }}
        </span>
          </template>
        </el-table-column>
        <el-table-column label="咨询师" min-width="8%">
          <template slot-scope="scope">
        <span style="">
          {{ scope.row.ConsultName }}
        </span>
          </template>
        </el-table-column>
        <el-table-column label="咨询方式" min-width="8%">
          <template slot-scope="scope">
        <span style="">
          {{scope.row.ConsultType == 0 ? "面对面咨询":"远程视频"}}
        </span>
          </template>
        </el-table-column>
        <el-table-column label="咨询地址/视频号" min-width="14%">
          <template slot-scope="scope">
        <span style="">
          {{scope.row.ConsultType == 0 ?scope.row.ConsultAddress:scope.row.VideoAccount}}
        </span>
          </template>
        </el-table-column>
        <el-table-column label="咨询类型" min-width="8%">
          <template slot-scope="scope">
        <span style="">
          {{scope.row.IsLongConsult == 0 ? "非长期咨询":"长期咨询"}}
        </span>
          </template>
        </el-table-column>
        <el-table-column label="预约时间" min-width="14%">
          <template slot-scope="scope">
        <span style="">
          {{ scope.row.AppointmentTime }}
        </span>
          </template>
        </el-table-column>
<!--        <el-table-column label="剩余次数" min-width="7%">-->
<!--          <template slot-scope="scope">-->
<!--        <span style="">-->
<!--          {{ scope.row.RemainTimes }}-->
<!--        </span>-->
<!--          </template>-->
<!--        </el-table-column>-->

        <el-table-column :label="$t('original.languages49')" min-width="20%">
          <template slot-scope="scope">
            <el-button @click="getCancelDialog(scope.row)" v-if="scope.row.State== '1' && scope.row.Type==1">取消咨询</el-button>
            <el-button @click="getCancelDialog(scope.row)" v-if="scope.row.Type==2">取消候补</el-button>
            <el-button @click="getDetailDialog(scope.row)">预约详情</el-button>
<!--              <el-button size="mini" @click="handleEdit(scope.row)">-->
<!--                {{ $t('original.editor') }}-->
<!--              </el-button>-->
<!--              <el-button size="mini" type="danger" @click="handleDelete(scope.row)">-->
<!--                {{ $t('original.delete') }}-->
<!--              </el-button>-->
          </template>
        </el-table-column>
      </el-table>
      <div class="cancelWarn">温馨提示：提前24小时取消预约，不消耗次数</div>


      <el-dialog title="预约详情" :visible.sync="detailVisible">
<!--      <div class="myAppointment"  v-for="(item, itemIndex) in myInterview" :key="itemIndex">-->
        <el-form>
          <div class="AppointmentDate">
            <div>
              咨询日期：<b>{{detailConsult.SchedulDate}}</b>
            </div>
            <span>{{detailConsult.Status}}</span>
          </div>
          <div class="AppointmentStatus" v-if="detailConsult.Status=='待咨询' && detailConsult.Type==1">未开始</div>
          <div class="AppointmentStatus" v-if="detailConsult.Status!='待咨询' && detailConsult.Type==1"> </div>
          <div class="AppointmentStatus blackFont" v-if="detailConsult.Type==2">您当前候选补在第<span>{{detailConsult.CandidateRank}}</span>位</div>
          <div class="AppointmentTime"><b>{{detailConsult.StartTime}}</b><span>--</span><b>{{detailConsult.FinishTime}}</b></div>
          <div class="AppointmentStatus otherInfo">
            <div><span class="tag"> 咨询师：</span><span>{{detailConsult.ConsultName}}</span></div>
            <div><span class="tag">{{detailConsult.ConsultType == 0 ?"咨询地址：":"视频号："}}</span><span>{{detailConsult.ConsultType == 0 ?detailConsult.ConsultAddress:detailConsult.VideoAccount}}</span></div>
          </div>
          <div class="AppointmentStatus otherInfo">
            <div><span class="tag">咨询方式：</span><span>{{detailConsult.ConsultType == 0 ? "面对面咨询":"远程视频"}}</span></div>
            <div><span class="tag">咨询类型：</span><span>{{detailConsult.IsLongConsult == 0 ? "非长期咨询":"长期咨询"}}</span></div>
          </div>
          <div class="AppointmentStatus otherInfo"><div><span class="tag">预约时间：</span><span>{{detailConsult.AppointmentTime}}</span></div></div>
          <div class="AppointmentStatus otherInfo"><div><span class="tag">剩余次数：</span><span>{{detailConsult.RemainTimes}}</span></div></div>
          <div class="AppointmentStatus otherInfo" v-if="detailConsult.CancelCause!=''"><div><span class="tag">取消原因：</span><span style="text-align: left">{{detailConsult.CancelCause}}</span></div></div>
<!--          <div class="AppointmentStatus otherInfo"><div><span class="tag">取消原因：</span><span>中国电影在近年来蓬勃发展，取得了国际上的认可。一些中国导演将中国传统文化融入电影创作中，以其独特的视角讲述故事，使中国电影在全球范围内受到关注。通过创新的手法，中国电影成功地传递了中华文化的魅力，同时也赢得了现代观众的喜爱。中国电影在近年来蓬勃发展，取得了国际上的认可。一些中国导演将中国传统文化融入电影创作中，以其独特的视角讲述故事，使中国电影在全球范围内受到关注。通过创新的手法，中国电影成功地传递了中华文化的魅力，同时也赢得了现代观众的喜爱。</span></div></div>-->
          <div class="buttonBlock">
<!--            <el-button type="primary" @click="enterInterview(item.TencentLink)" v-if="item.State== '1' && item.Type==1">进入咨询</el-button>-->
<!--            <el-button @click="getCancelDialog(item)" v-if="item.State== '1' && item.Type==1">取消咨询</el-button>-->
            <el-button @click="detailVisible = false">关闭</el-button>

          </div>
        </el-form>
<!--      </div>-->
      </el-dialog>
      <el-dialog :title="selConsult.Type ==1 ? '取消咨询':'取消候补'" :visible.sync="dialogFormVisible">
        <el-form :model="cancelData">
          <el-form-item label="咨询师：" :label-width="formLabelWidth">
            <span>{{this.selConsult.ConsultName}}</span>
          </el-form-item>
          <el-form-item label="咨询时间：" :label-width="formLabelWidth">
            <span>{{this.selConsult.SchedulDate}} &nbsp; &nbsp; {{this.selConsult.StartTime}}-{{this.selConsult.FinishTime}}</span>
          </el-form-item>
          <el-form-item label="剩余次数：" :label-width="formLabelWidth">
            <span>{{this.selConsult.RemainTimes}}</span>
          </el-form-item>
          <el-form-item label="取消原因：" :label-width="formLabelWidth">
            <el-input
                    maxlength="200"
                    type="textarea"
                    :rows="2"
                    placeholder="请输入取消原因，通知咨询师！"
                    v-model="cancelData.CancelCause">
            </el-input>
          </el-form-item>

        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="cancelInterview()">确定取消</el-button>
        </div>
      </el-dialog>
    </el-main>
  </el-container>
</template>

<script>
export default {
  mounted() {
    this.loadMyInterview(this.Global.userID);
  },
  data() {
    return {
      detailVisible:false,
      detailConsult:{

      },
      dialogFormVisible:false,
      selConsult:{

      },
      formLabelWidth: '120px',
      myInterview:[],
      cancelData:{
        AppointmentID: '',	//预约编号
        CancelCause: '',	//取消理由
        Type:0,
        CounselorFlag:'0',
      },
    };
  },
  props: {
    showToday: {
      type: Boolean,
      default: true, //是否显示返回今天按钮
    },
  },
  methods: {
    loadMyInterview(UserID) {
      //列表
      this.$Http_Post('ConsultAppoint/GetMyAppointList', {
        UserID:UserID,State:"",
      }).then((res) => {
        if (res.Code == 0) {
          console.warn(res.Data);
          this.myInterview = res.Data;
        }
      });
    },
    getCancelDialog(item){
      this.dialogFormVisible = true;
      this.selConsult =item;
      this.selConsult.StartTime =item.StartTime.substring(0,5);
      this.selConsult.FinishTime =item.FinishTime.substring(0,5);
      this.cancelData.AppointmentID = item.AppointmentID;
      this.cancelData.Type = item.Type;
    },
    getDetailDialog(item){
      this.detailVisible = true;
      this.detailConsult =item;
      this.detailConsult.StartTime =item.StartTime.substring(0,5);
      this.detailConsult.FinishTime =item.FinishTime.substring(0,5);
    },
    cancelInterview() {
      //处理传入的参数
      // console.warn("11111")
      // debugger;
      this.$Http_Post('ConsultAppoint/CancelMyAppoint', this.cancelData).then((res) => {
        if (res.Code == 0) {
          // console.warn(this.Global.SourceNo+"111");
          // debugger;
          if(this.selConsult.Type == 1){
            this.Global.request_successful("取消咨询成功");
          }else if(this.selConsult.Type == 2){
            this.Global.request_successful("取消候补成功");
          }
          setTimeout(function() {
            location.reload();// 需要执行的代码
          }, 500);
          // console.warn(this.Global.SourceNo);
        }else{
          this.Global.request_failure(res.Message);
        }
      });
      this.dialogFormVisible = false;
    },
    // enterInterview (link) {
    //   // window.location.href = link;
    //   window.open(link, '_blank')
    // },
  },
}
</script>
<style>
/*.CalendarLayout .myAppointment {*/
/*  border: 1px solid rgba(222, 222, 222, 1);*/
/*  border-radius: 4px;*/
/*  font-size: 17px;*/
/*  color: #666;*/
/*  width: 360px;*/
/*  padding: 30px;*/
/*  float: left;*/
/*  margin-left: 20px;*/
/*  margin-top: 20px;*/
/*}*/
.CalendarLayout .AppointmentDate {
  font-size: 17px;
  color: #666;
  font-weight: bold;
  display: flex;
  justify-content:space-between;
}

.CalendarLayout .AppointmentDate span {
  font-size: 14px;
  color: #0d78e3;
}
.CalendarLayout .AppointmentStatus {
  font-size: 14px;
  color:rgba(238, 10, 36, 1);
  text-align: center;
  padding-top: 25px;
  min-height: 20px;
}
.CalendarLayout .blackFont {
  color:#333;
}
.CalendarLayout .otherInfo {
  padding-top: 10px;
  padding-bottom: 10px;
  display: flex;
  flex-direction: row;
  justify-content:flex-start;
  color:#333;
  border-bottom: 1px dashed #eee;
}
.CalendarLayout .otherInfo div {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  min-width: 50%;
}
.CalendarLayout .otherInfo span {
  display: inline-block;
}
.CalendarLayout .otherInfo .tag {
  min-width: 80px;
  text-align: right;
}
/*.CalendarLayout .red {*/
/*  color:rgba(238, 10, 36, 1);*/
/*  font-weight: bold;*/
/*}*/
.CalendarLayout .AppointmentTime {
  font-size: 26px;
  color: #ccc;
  display: flex;
  justify-content:space-around;
  padding-left: 40px;
  padding-right: 40px;
  padding-bottom: 15px;
  border-bottom: 1px dashed #eee;
}
.CalendarLayout .AppointmentTime b {
  font-size: 26px;
  color: #333;
}
.CalendarLayout .AppointmentTime .time {
  font-size: 14px;
  color: #999;
  padding:6px;
  background-color: #eee;
}
.CalendarLayout .buttonBlock {
  padding-top: 30px;
  text-align: center;
  height: 45px;
}
.CalendarLayout .cancelWarn {
  padding-top: 10px;
  font-size: 16px;
  color: #d48c4e;
  padding-bottom: 8px;
}

</style>
